import BaseComponent from "../../../../baseComponent.js";
import DatasetService from "../../../../../core/services/datasetService.js";
import styles from "./dataprofile.scss";

const VALUE_TYPES = ["", "DOUBLE", "FLOAT", "BYTE", "SHORT", "INT", "LONG", "BOOLEAN", "STRING"];

class DataProfileField extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.field}>
        <div className={styles.fieldName}>{this.props.field.name}</div>
        <div className={styles.fieldId}>{this.props.field.fieldId}</div>
        <div>{VALUE_TYPES[this.props.field.valueType]}</div>
      </div>
    )
  }
}

export default class DataProfile extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      description: "",
      fields: []
    }
  }

  componentWillMount() {
    DatasetService.getDataProfileById(this.props.dataset.dataProfileId, (response) => {
      this.setState({
        name: response.data[0].name,
        description: response.data[0].description,
        fields: response.data[0].fields,
        createDatasetEventTypeId: response.data[0].createDatasetEventTypeId
      })
    })
  }

  copyDatasetId() {
    this.refs.profileId.select();
    try {
      document.execCommand('copy');
      this.refs.profileId.blur();
    }
    catch (err) {
    }
  }

  render() {
    let fields = [];
    for (let i = 0; i < this.state.fields.length; i++) {
      if (this.state.fields[i].fieldId == null) {
        break;
      }
      fields.push(<DataProfileField field={this.state.fields[i]} key={i}/>);
    }
    return (
      <div className={styles.container}>
        <div className={styles.profileDetail}>
          <span className={styles.profileName}>{this.state.name}</span>
          <div className={["waves-effect waves-light btn", styles.profileUUID].join(" ")} onClick={this.copyDatasetId}>
            <input type="text" ref="profileId" value={this.state.createDatasetEventTypeId} readOnly/>
          </div>
        </div>
        <div className={styles.header}>
          <div className={styles.headerName}>Field Name</div>
          <div className={styles.headerId}>Field Id</div>
          <div className={styles.headerType}>Field Type</div>
        </div>
        <div className={styles.fields}>
          {fields}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/dataprofile/dataprofile.jsx